import Swal from "sweetalert2";
import moment from "moment";
import { displayDate } from "../../../izUtils";

export const handleDay = (t, date, tech) => {
    let title = tech.name + ', ' + displayDate(date, 'date');
    let html = '';
    let confirmButtonText = t('close');
    const dateParam = moment(date).format('YYYY-MM-DD');

    html = `
        <div class="mb-3"><a href="/schedule/task/create?date=${dateParam}&tech=${tech.id}">Dodaj izvedbo</a></div>
        <div class="mb-3"><a href="/schedule/events/create?date=${dateParam}&tech=${tech.id}">Dodaj izvedbo na projektu</a></div>
        <div class="mb-3"><a href="/schedule/exception/create?date=${dateParam}&tech=${tech.id}">Dodaj izjemo tehnika</a></div>
    `;

    Swal.fire({
        title,
        html,
        confirmButtonColor: 'var(--theme-default)',
        confirmButtonText,
    })
}